/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import MenuPayment from "../MenuPayment";
import MenuUser from "../MenuUser";
import Surplus from "../Surplus";

const Sider = () => {
  return (
    <div
      css={css`
        min-width: 300px;
        height: 100%;
      `}
    >
      <Surplus />
      <MenuPayment />
      <MenuUser />
    </div>
  );
};

export default Sider;
